(function () {
  'use strict';

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function textOf(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function hasName(el) {
    if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || el.getAttribute('title')) return true;
    if (textOf(el)) return true;
    var img = el.querySelector('img[alt]');
    return !!(img && img.getAttribute('alt').trim());
  }

  var PANEL_LABELS = [
    ['#header-sidebar-menu', 'Menu'],
    ['cart-drawer, cart-notification-drawer', 'Cart'],
    ['#search-drawer, search-drawer', 'Search'],
    ['#newsletter-drawer, newsletter-popup', 'Newsletter signup'],
    ['product-quick-buy, #quick-buy-drawer, [id^="quick-buy"]', 'Quick buy']
  ];

  function labelPanels() {
    PANEL_LABELS.forEach(function (pair) {
      all(pair[0]).forEach(function (el) {
        if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
          el.setAttribute('aria-label', pair[1]);
        }
        if (el.tagName !== 'DIALOG' && !el.getAttribute('role')) {
          el.setAttribute('role', 'dialog');
        }
      });
    });

    all('x-popover').forEach(function (el) {
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;
      var title = el.querySelector('[slot="title"]');
      if (title && textOf(title)) el.setAttribute('aria-label', textOf(title));
    });

    all('x-listbox').forEach(function (el) {
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;
      var popover = el.closest('x-popover');
      var title = popover && popover.querySelector('[slot="title"]');
      if (title && textOf(title)) el.setAttribute('aria-label', textOf(title));
    });
  }

  function labelControls() {
    all('.qq-video-thumb').forEach(function (a, index) {
      var wrapper = a.closest('.qq-single-video');
      var titleEl = wrapper && wrapper.querySelector('.qq-video-title');
      var title = titleEl ? textOf(titleEl) : '';
      var img = a.querySelector('img');
      if (!title && img && img.getAttribute('alt')) title = img.getAttribute('alt').trim();
      a.setAttribute('aria-label', 'Play video: ' + (title || 'video ' + (index + 1)));
      if (img && !img.hasAttribute('alt')) img.setAttribute('alt', '');
      if (img && img.getAttribute('alt') === title) img.setAttribute('alt', '');
    });

    all('.qq-close').forEach(function (a) {
      if (!hasName(a)) a.setAttribute('aria-label', 'Close video');
    });

    all('a[href*="shopify.com"]').forEach(function (a) {
      if (!hasName(a)) a.setAttribute('aria-label', 'Powered by Shopify');
    });

    all('form[role="search"] button[type="submit"]').forEach(function (b) {
      if (!hasName(b)) b.setAttribute('aria-label', 'Search');
    });
  }

  function fixTabs() {
    all('x-tabs').forEach(function (tabs) {
      all('[slot="title"]', tabs).forEach(function (button) {
        if (button.tagName === 'BUTTON' && !button.getAttribute('role')) {
          button.setAttribute('role', 'tab');
        }
        if (button.getAttribute('role') === 'tab' && !button.hasAttribute('aria-selected')) {
          button.setAttribute('aria-selected', 'false');
        }
        var panelId = button.getAttribute('controlled-panel');
        if (panelId && document.getElementById(panelId) && !button.getAttribute('aria-controls')) {
          button.setAttribute('aria-controls', panelId);
        }
      });
    });
  }

  function fixImages() {
    all('img').forEach(function (img) {
      var alt = img.getAttribute('alt');

      if (alt === null) {
        img.setAttribute('alt', '');
        return;
      }

      if (/^feature-item-\d+$/i.test(alt.trim()) || /\.(jpe?g|png|webp|gif|svg)$/i.test(alt.trim())) {
        img.setAttribute('alt', '');
        return;
      }

      var suffix = /\s+-\s+[^-]*peachiespeechie\.com\s*$/i;
      if (suffix.test(alt)) {
        var cleaned = alt.replace(suffix, '').trim();
        if (cleaned) img.setAttribute('alt', cleaned);
      }
    });

    all('.header__logo-image').forEach(function (img) {
      if (img.closest('a') && img.parentElement.querySelector('.sr-only')) img.setAttribute('alt', '');
    });
  }

  var TITLE_SPLIT = new RegExp('\\s[' + String.fromCharCode(8211, 8212) + '|-]\\s');

  function fixHeadings() {
    var main = document.getElementById('main') || document.querySelector('main');
    if (!main) return;

    if (!document.querySelector('h1, [role="heading"][aria-level="1"]')) {
      var title = (document.title || '').split(TITLE_SPLIT)[0].trim();
      if (title) {
        var h1 = document.createElement('h1');
        h1.className = 'sr-only';
        h1.setAttribute('data-a11y-added', 'true');
        h1.textContent = title;
        main.insertBefore(h1, main.firstChild);
      }
    }

    var previous = 0;
    all('h1, h2, h3, h4, h5, h6').forEach(function (heading) {
      if (heading.closest('template, [hidden], [aria-hidden="true"]')) return;
      if (heading.hasAttribute('data-a11y-level')) {
        heading.removeAttribute('aria-level');
        heading.removeAttribute('data-a11y-level');
      }
      var level = parseInt(heading.tagName.charAt(1), 10);
      if (previous && level > previous + 1) {
        level = previous + 1;
        heading.setAttribute('aria-level', String(level));
        heading.setAttribute('data-a11y-level', 'true');
      }
      previous = level;
    });
  }

  function fixIframes() {
    all('iframe').forEach(function (frame) {
      if (frame.getAttribute('title')) return;
      var src = frame.getAttribute('src') || frame.getAttribute('data-src') || '';
      if (/youtube|youtu\.be/i.test(src)) frame.setAttribute('title', 'YouTube video player');
      else if (/vimeo/i.test(src)) frame.setAttribute('title', 'Vimeo video player');
      else if (src) frame.setAttribute('title', 'Embedded content');
    });
  }

  var focusReturn = null;

  function focusablesIn(el) {
    return all('input:not([type="hidden"]):not([disabled]), button:not([disabled]), a[href], select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (node) { return node.offsetParent !== null || node === document.activeElement; });
  }

  function handlePopupState(popup) {
    var isOpen = popup.hasAttribute('open');
    var wasOpen = popup.getAttribute('data-a11y-open') === 'true';
    if (isOpen === wasOpen) return;
    popup.setAttribute('data-a11y-open', isOpen ? 'true' : 'false');

    if (isOpen) {
      focusReturn = document.activeElement;
      popup.setAttribute('aria-modal', 'true');
      setTimeout(function () {
        var email = popup.querySelector('input[type="email"]');
        var target = email || focusablesIn(popup)[0];
        if (target) target.focus();
      }, 150);
    } else if (focusReturn && typeof focusReturn.focus === 'function') {
      focusReturn.focus();
      focusReturn = null;
    }
  }

  function watchPopups() {
    all('newsletter-popup').forEach(function (popup) {
      if (popup.hasAttribute('data-a11y-watched')) return;
      popup.setAttribute('data-a11y-watched', 'true');
      new MutationObserver(function () { handlePopupState(popup); })
        .observe(popup, { attributes: true, attributeFilter: ['open'] });
      handlePopupState(popup);

      popup.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab' || !popup.hasAttribute('open')) return;
        var items = focusablesIn(popup);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    });
  }

  function run() {
    labelPanels();
    labelControls();
    fixTabs();
    fixImages();
    fixHeadings();
    fixIframes();
    watchPopups();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      run();
    }, 200);
  }

  function start() {
    run();
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        if (m.type === 'attributes') return false;
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && !n.hasAttribute('data-a11y-added');
        });
      });
      if (relevant) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', schedule);
})();
